<template>
  <div class="col-xs-12 col-md-4">
    <div class="machine-item">
      <div class="red-bumper-desktop">14 Tage kostenlos testen</div>
      <MachineItemsImageWrapper
        :resultIndex="0"
        :randomPercentNumber="topPercentNumber"
        :result="result"
      />
      <div class="machine-information-wrapper">
        <MachineItemsInformationsContent
          :financeTypeLength="financeTypeLength"
          :financeType="financeType"
          :result="result"
          :ab_test="ab_test"
          :hidePrices="hidePrices"
        />
      </div>
      <MachineLegalText v-if="ab_test != true && hidePrices != true" />
    </div>
  </div>
</template>

<script>
import MachineItemsImageWrapper from './MachineItemsImageWrapper'
import MachineItemsInformationsContent from './MachineItemsInformationsContent'
import MachineLegalText from './MachineLegalText'

export default {
  components: {
    MachineItemsImageWrapper,
    MachineItemsInformationsContent,
    MachineLegalText
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    topPercentNumber: {
      type: Number,
      default: 0
    },
    financeTypeLength: {
      type: Number,
      default: 0
    },
    financeType: {
      type: [String, Array]
    },
    ab_test: {
      type: Boolean
    },
    hidePrices: {
      type: Boolean
    }
  }
}
</script>
